import React from "react";
import "./ECommerceSolution.css";
import {
  CheckCircleFilled,
  ArrowRightOutlined,
  ShoppingCartOutlined,
  SafetyCertificateOutlined,
  CloudOutlined,
  RocketOutlined,
  CheckOutlined,
  ThunderboltFilled,
  ShopOutlined,
  CreditCardOutlined,
  GlobalOutlined,
} from "@ant-design/icons";
import ecommerceImage from "../../Asset/e-commerce.png";

const featuresLeft = [
  "Product Catalog Management",
  "Shopping Cart & Easy Checkout",
  "Secure Payment Gateway Integration",
  "Order Processing & Tracking",
  "Customer Account & Wishlist",
  "Inventory & Stock Level Alerts",
  "Discount, Coupons & Promo Codes",
  "Multi-Vendor Marketplace Support",
  "Product Reviews and Ratings",
  "Automatic Tax & Shipping Calculator",
];

const featuresRight = [
  "Multi-Currency & Language Support",
  "100% Mobile Responsive Design",
  "Real-Time Sales Analytics & Reports",
  "SEO-Friendly URL & Metadata",
  "Email & SMS Marketing Integration",
  "Live Chat & Customer Support CRM",
  "Bulk Product Import/Export (CSV)",
  "Returns & Refunds Management",
  "Social Media Store Integration",
  "Secure Admin Dashboard & Roles",
];

const highlights = [
  {
    icon: <ShopOutlined />,
    title: "Online Storefront",
    desc: "Beautiful storefront & catalog",
  },
  {
    icon: <CreditCardOutlined />,
    title: "Secure Payments",
    desc: "Trusted gateway integrations",
  },
  {
    icon: <GlobalOutlined />,
    title: "Global Reach",
    desc: "Multi-currency & multi-language",
  },
];

const ECommerceSolution = () => {
  const handleViewMore = () => {
    window.open("/ecommerce-details", "_blank");
  };

  return (
    <div className="ecs-page-light">
      {/* Decorative Background */}
      <div className="ecs-bg-grid"></div>
      <div className="ecs-glow-1"></div>
      <div className="ecs-glow-2"></div>

      <div className="ecs-container">
        
        {/* ═══════ PROFESSIONAL HEADER ═══════ */}
        <div className="ecs-header-new">
          <div className="ecs-header-top">
            <span className="ecs-badge">
              <span className="ecs-badge-dot"></span>
              E-COMMERCE PLATFORM
            </span>
            <span className="ecs-version-tag">
              <ThunderboltFilled /> Version 5.0
            </span>
          </div>

          <div className="ecs-header-main">
            <div className="ecs-header-icon-box">
              <ShoppingCartOutlined />
            </div>
            <div className="ecs-header-text">
              <h1 className="ecs-title-new">
                E-Commerce <span className="ecs-gradient-text">Solution</span>
              </h1>
              <p className="ecs-subtitle-new">
                A comprehensive digital commerce platform designed to help retailers 
                and brands build, launch, manage, and scale their online stores 
                effortlessly with secure checkouts, multi-vendor support, and global reach.
              </p>
            </div>
          </div>

          {/* Meta Info Pills */}
          <div className="ecs-meta-pills">
            <span className="ecs-meta-pill">
              <CheckOutlined /> Live Demo Available
            </span>
            <span className="ecs-meta-pill">
              <SafetyCertificateOutlined /> PCI DSS Compliant
            </span>
            <span className="ecs-meta-pill">
              <CloudOutlined /> Cloud-Based Software
            </span>
            <span className="ecs-meta-pill">
              <RocketOutlined /> 24/7 Support Included
            </span>
          </div>
        </div>

        {/* MAIN CONTENT GRID */}
        <div className="ecs-main-content">
          
          {/* LEFT — IMAGE & HIGHLIGHTS */}
          <div className="ecs-left-col">
            <div className="ecs-image-wrapper">
              <div className="ecs-image-glow"></div>
              <img
                src={ecommerceImage}
                alt="E-Commerce Solution"
                className="ecs-image"
              />
              <div className="ecs-image-badge">
                <ShoppingCartOutlined /> Store Dashboard
              </div>
            </div>

            {/* Highlights Row */}
            <div className="ecs-highlights">
              {highlights.map((item, index) => (
                <div className="ecs-highlight-card" key={index}>
                  <div className="ecs-highlight-icon">{item.icon}</div>
                  <div className="ecs-highlight-text">
                    <h5>{item.title}</h5>
                    <p>{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* RIGHT — INFORMATION */}
          <div className="ecs-right-col">
            <div className="ecs-info-block">
              <p className="ecs-para">
                Our <strong>E-Commerce Solution</strong> is a comprehensive digital 
                platform designed to help retailers and businesses build, manage, 
                and scale their online stores. It automates everything from product 
                display to secure checkout, making online selling absolutely seamless.
              </p>

              <p className="ecs-para">
                Whether you are a <strong>startup or an established global brand</strong>, 
                this platform delivers secure database integration, robust inventory 
                control, and lightning-fast load times. Expand your reach worldwide 
                and deliver an exceptional shopping experience to your customers.
              </p>
            </div>

            {/* FEATURES SECTION */}
            <div className="ecs-features-section">
              <h2 className="ecs-features-title">
                <span className="title-accent">Key Features</span> & Benefits
              </h2>
              <p className="ecs-features-desc">
                Explore our complete suite of powerful features engineered to transform 
                your online retail business into a global e-commerce powerhouse.
              </p>

              <div className="ecs-features-grid">
                <ul className="ecs-features-list">
                  {featuresLeft.map((feature, index) => (
                    <li key={index}>
                      <CheckCircleFilled className="ecs-check-icon" />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>

                <ul className="ecs-features-list">
                  {featuresRight.map((feature, index) => (
                    <li key={index}>
                      <CheckCircleFilled className="ecs-check-icon" />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            {/* CTA BUTTON */}
            {/* <div className="ecs-cta-wrap">
              <button className="ecs-view-btn" onClick={handleViewMore}>
                <span>Explore Full Details</span>
                <ArrowRightOutlined />
              </button>
              <p className="ecs-cta-note">
                💡 Get a live demo and pricing consultation
              </p>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ECommerceSolution;